import React from 'react'
import { Icons } from '@pankod/refine-antd'
import { useCan } from '@pankod/refine-core'

import ActivityListDrawer, {
  useActivityListDrawer,
} from '../../../../program-setup/blocks/blueprint/ActivityListDrawer'
import BlueprintRegistrationDrawer, {
  useBlueprintRegistrationDrawer,
} from '../../../../program-setup/blocks/blueprint/BlueprintRegistrationDrawer'
import { PROGRAM_STATE } from '../../../../types'
import { Highlighter } from '../../utils'

import type {
  TConfigurationSection,
  TConfigurationSectionContext,
} from '../types'

export const useBlueprintConfiguration = ({
  isOwner,
  program,
  programId,
  runAndClose,
  search,
}: TConfigurationSectionContext): TConfigurationSection => {
  const { show: showRegistration, ...registrationDrawerProps } =
    useBlueprintRegistrationDrawer()
  const { show: showActivityList, ...activityListDrawerProps } =
    useActivityListDrawer()
  const { data: canRegister } = useCan({
    action: 'field',
    resource: 'lms-program-management',
    params: { field: 'blueprint-registration' },
  })
  const visible =
    (canRegister?.can || isOwner) && program?.status !== PROGRAM_STATE.ENDED

  return {
    menuItems: visible
      ? [
          {
            type: 'group',
            label: <Highlighter search={search} text="Blueprint" />,
            key: 'Blueprint',
            children: [
              {
                icon: <Icons.BlockOutlined />,
                label: (
                  <Highlighter search={search} text="Registrasi Blueprint" />
                ),
                key: 'Registrasi Blueprint',
                onClick: () => runAndClose(() => showRegistration(programId)),
              },
              {
                icon: <Icons.UnorderedListOutlined />,
                label: (
                  <Highlighter search={search} text="Daftar Aktivitas Canvas" />
                ),
                key: 'Daftar Aktivitas Canvas',
                onClick: () =>
                  runAndClose(() =>
                    showActivityList(programId, program?.name!),
                  ),
              },
            ],
          },
        ]
      : [],
    overlays: (
      <>
        <BlueprintRegistrationDrawer
          {...registrationDrawerProps}
          initialSisIdAccount={program?.sisAccountId}
        />
        <ActivityListDrawer {...activityListDrawerProps} />
      </>
    ),
  }
}
